// extracted by mini-css-extract-plugin
export default {"root":"Mc7onJ","label":"LbXNab"};